class je extends Error {
  code;
  errorData;
  constructor(t, r, n) {
    super(t), this.name = "HeError", this.code = r, this.errorData = n;
  }
}
function Je(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: mt } = Object.prototype, { getPrototypeOf: ye } = Object, { iterator: te, toStringTag: $e } = Symbol, re = /* @__PURE__ */ ((e) => (t) => {
  const r = mt.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), A = (e) => (e = e.toLowerCase(), (t) => re(t) === e), ne = (e) => (t) => typeof t === e, { isArray: q } = Array, D = ne("undefined");
function H(e) {
  return e !== null && !D(e) && e.constructor !== null && !D(e.constructor) && S(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const We = A("ArrayBuffer");
function bt(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && We(e.buffer), t;
}
const yt = ne("string"), S = ne("function"), Ve = ne("number"), J = (e) => e !== null && typeof e == "object", gt = (e) => e === !0 || e === !1, Z = (e) => {
  if (re(e) !== "object")
    return !1;
  const t = ye(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !($e in e) && !(te in e);
}, wt = (e) => {
  if (!J(e) || H(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, Et = A("Date"), Ot = A("File"), Rt = A("Blob"), St = A("FileList"), Tt = (e) => J(e) && S(e.pipe), At = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || S(e.append) && ((t = re(e)) === "formdata" || // detect form-data instance
  t === "object" && S(e.toString) && e.toString() === "[object FormData]"));
}, Ct = A("URLSearchParams"), [jt, vt, xt, Ut] = ["ReadableStream", "Request", "Response", "Headers"].map(A), Nt = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function $(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let n, o;
  if (typeof e != "object" && (e = [e]), q(e))
    for (n = 0, o = e.length; n < o; n++)
      t.call(null, e[n], n, e);
  else {
    if (H(e))
      return;
    const i = r ? Object.getOwnPropertyNames(e) : Object.keys(e), s = i.length;
    let l;
    for (n = 0; n < s; n++)
      l = i[n], t.call(null, e[l], l, e);
  }
}
function Ke(e, t) {
  if (H(e))
    return null;
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, o;
  for (; n-- > 0; )
    if (o = r[n], t === o.toLowerCase())
      return o;
  return null;
}
const L = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Xe = (e) => !D(e) && e !== L;
function de() {
  const { caseless: e, skipUndefined: t } = Xe(this) && this || {}, r = {}, n = (o, i) => {
    const s = e && Ke(r, i) || i;
    Z(r[s]) && Z(o) ? r[s] = de(r[s], o) : Z(o) ? r[s] = de({}, o) : q(o) ? r[s] = o.slice() : (!t || !D(o)) && (r[s] = o);
  };
  for (let o = 0, i = arguments.length; o < i; o++)
    arguments[o] && $(arguments[o], n);
  return r;
}
const Pt = (e, t, r, { allOwnKeys: n } = {}) => ($(t, (o, i) => {
  r && S(o) ? e[i] = Je(o, r) : e[i] = o;
}, { allOwnKeys: n }), e), Ft = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Lt = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, _t = (e, t, r, n) => {
  let o, i, s;
  const l = {};
  if (t = t || {}, e == null) return t;
  do {
    for (o = Object.getOwnPropertyNames(e), i = o.length; i-- > 0; )
      s = o[i], (!n || n(s, e, t)) && !l[s] && (t[s] = e[s], l[s] = !0);
    e = r !== !1 && ye(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, kt = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, Bt = (e) => {
  if (!e) return null;
  if (q(e)) return e;
  let t = e.length;
  if (!Ve(t)) return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, Dt = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && ye(Uint8Array)), qt = (e, t) => {
  const r = (e && e[te]).call(e);
  let n;
  for (; (n = r.next()) && !n.done; ) {
    const o = n.value;
    t.call(e, o[0], o[1]);
  }
}, Mt = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, zt = A("HTMLFormElement"), It = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, r, n) {
    return r.toUpperCase() + n;
  }
), ve = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), Ht = A("RegExp"), Ge = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  $(r, (o, i) => {
    let s;
    (s = t(o, i, e)) !== !1 && (n[i] = s || o);
  }), Object.defineProperties(e, n);
}, Jt = (e) => {
  Ge(e, (t, r) => {
    if (S(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = e[r];
    if (S(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, $t = (e, t) => {
  const r = {}, n = (o) => {
    o.forEach((i) => {
      r[i] = !0;
    });
  };
  return q(e) ? n(e) : n(String(e).split(t)), r;
}, Wt = () => {
}, Vt = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function Kt(e) {
  return !!(e && S(e.append) && e[$e] === "FormData" && e[te]);
}
const Xt = (e) => {
  const t = new Array(10), r = (n, o) => {
    if (J(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (H(n))
        return n;
      if (!("toJSON" in n)) {
        t[o] = n;
        const i = q(n) ? [] : {};
        return $(n, (s, l) => {
          const f = r(s, o + 1);
          !D(f) && (i[l] = f);
        }), t[o] = void 0, i;
      }
    }
    return n;
  };
  return r(e, 0);
}, Gt = A("AsyncFunction"), Zt = (e) => e && (J(e) || S(e)) && S(e.then) && S(e.catch), Ze = ((e, t) => e ? setImmediate : t ? ((r, n) => (L.addEventListener("message", ({ source: o, data: i }) => {
  o === L && i === r && n.length && n.shift()();
}, !1), (o) => {
  n.push(o), L.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  S(L.postMessage)
), Qt = typeof queueMicrotask < "u" ? queueMicrotask.bind(L) : typeof process < "u" && process.nextTick || Ze, Yt = (e) => e != null && S(e[te]), a = {
  isArray: q,
  isArrayBuffer: We,
  isBuffer: H,
  isFormData: At,
  isArrayBufferView: bt,
  isString: yt,
  isNumber: Ve,
  isBoolean: gt,
  isObject: J,
  isPlainObject: Z,
  isEmptyObject: wt,
  isReadableStream: jt,
  isRequest: vt,
  isResponse: xt,
  isHeaders: Ut,
  isUndefined: D,
  isDate: Et,
  isFile: Ot,
  isBlob: Rt,
  isRegExp: Ht,
  isFunction: S,
  isStream: Tt,
  isURLSearchParams: Ct,
  isTypedArray: Dt,
  isFileList: St,
  forEach: $,
  merge: de,
  extend: Pt,
  trim: Nt,
  stripBOM: Ft,
  inherits: Lt,
  toFlatObject: _t,
  kindOf: re,
  kindOfTest: A,
  endsWith: kt,
  toArray: Bt,
  forEachEntry: qt,
  matchAll: Mt,
  isHTMLForm: zt,
  hasOwnProperty: ve,
  hasOwnProp: ve,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Ge,
  freezeMethods: Jt,
  toObjectSet: $t,
  toCamelCase: It,
  noop: Wt,
  toFiniteNumber: Vt,
  findKey: Ke,
  global: L,
  isContextDefined: Xe,
  isSpecCompliantForm: Kt,
  toJSONObject: Xt,
  isAsyncFn: Gt,
  isThenable: Zt,
  setImmediate: Ze,
  asap: Qt,
  isIterable: Yt
};
function m(e, t, r, n, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), o && (this.response = o, this.status = o.status ? o.status : null);
}
a.inherits(m, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: a.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Qe = m.prototype, Ye = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Ye[e] = { value: e };
});
Object.defineProperties(m, Ye);
Object.defineProperty(Qe, "isAxiosError", { value: !0 });
m.from = (e, t, r, n, o, i) => {
  const s = Object.create(Qe);
  a.toFlatObject(e, s, function(c) {
    return c !== Error.prototype;
  }, (c) => c !== "isAxiosError");
  const l = e && e.message ? e.message : "Error", f = t == null && e ? e.code : t;
  return m.call(s, l, f, r, n, o), e && s.cause == null && Object.defineProperty(s, "cause", { value: e, configurable: !0 }), s.name = e && e.name || "Error", i && Object.assign(s, i), s;
};
const er = null;
function he(e) {
  return a.isPlainObject(e) || a.isArray(e);
}
function et(e) {
  return a.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function xe(e, t, r) {
  return e ? e.concat(t).map(function(n, o) {
    return n = et(n), !r && o ? "[" + n + "]" : n;
  }).join(r ? "." : "") : t;
}
function tr(e) {
  return a.isArray(e) && !e.some(he);
}
const rr = a.toFlatObject(a, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function oe(e, t, r) {
  if (!a.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = a.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(p, h) {
    return !a.isUndefined(h[p]);
  });
  const n = r.metaTokens, o = r.visitor || c, i = r.dots, s = r.indexes, l = (r.Blob || typeof Blob < "u" && Blob) && a.isSpecCompliantForm(t);
  if (!a.isFunction(o))
    throw new TypeError("visitor must be a function");
  function f(p) {
    if (p === null) return "";
    if (a.isDate(p))
      return p.toISOString();
    if (a.isBoolean(p))
      return p.toString();
    if (!l && a.isBlob(p))
      throw new m("Blob is not supported. Use a Buffer instead.");
    return a.isArrayBuffer(p) || a.isTypedArray(p) ? l && typeof Blob == "function" ? new Blob([p]) : Buffer.from(p) : p;
  }
  function c(p, h, d) {
    let E = p;
    if (p && !d && typeof p == "object") {
      if (a.endsWith(h, "{}"))
        h = n ? h : h.slice(0, -2), p = JSON.stringify(p);
      else if (a.isArray(p) && tr(p) || (a.isFileList(p) || a.endsWith(h, "[]")) && (E = a.toArray(p)))
        return h = et(h), E.forEach(function(O, w) {
          !(a.isUndefined(O) || O === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? xe([h], w, i) : s === null ? h : h + "[]",
            f(O)
          );
        }), !1;
    }
    return he(p) ? !0 : (t.append(xe(d, h, i), f(p)), !1);
  }
  const u = [], b = Object.assign(rr, {
    defaultVisitor: c,
    convertValue: f,
    isVisitable: he
  });
  function y(p, h) {
    if (!a.isUndefined(p)) {
      if (u.indexOf(p) !== -1)
        throw Error("Circular reference detected in " + h.join("."));
      u.push(p), a.forEach(p, function(d, E) {
        (!(a.isUndefined(d) || d === null) && o.call(
          t,
          d,
          a.isString(E) ? E.trim() : E,
          h,
          b
        )) === !0 && y(d, h ? h.concat(E) : [E]);
      }), u.pop();
    }
  }
  if (!a.isObject(e))
    throw new TypeError("data must be an object");
  return y(e), t;
}
function Ue(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function ge(e, t) {
  this._pairs = [], e && oe(e, this, t);
}
const tt = ge.prototype;
tt.append = function(e, t) {
  this._pairs.push([e, t]);
};
tt.toString = function(e) {
  const t = e ? function(r) {
    return e.call(this, r, Ue);
  } : Ue;
  return this._pairs.map(function(r) {
    return t(r[0]) + "=" + t(r[1]);
  }, "").join("&");
};
function nr(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function rt(e, t, r) {
  if (!t)
    return e;
  const n = r && r.encode || nr;
  a.isFunction(r) && (r = {
    serialize: r
  });
  const o = r && r.serialize;
  let i;
  if (o ? i = o(t, r) : i = a.isURLSearchParams(t) ? t.toString() : new ge(t, r).toString(n), i) {
    const s = e.indexOf("#");
    s !== -1 && (e = e.slice(0, s)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class Ne {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    a.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const nt = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, or = typeof URLSearchParams < "u" ? URLSearchParams : ge, sr = typeof FormData < "u" ? FormData : null, ir = typeof Blob < "u" ? Blob : null, ar = {
  isBrowser: !0,
  classes: {
    URLSearchParams: or,
    FormData: sr,
    Blob: ir
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, we = typeof window < "u" && typeof document < "u", pe = typeof navigator == "object" && navigator || void 0, cr = we && (!pe || ["ReactNative", "NativeScript", "NS"].indexOf(pe.product) < 0), lr = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", ur = we && window.location.href || "http://localhost", fr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: we,
  hasStandardBrowserEnv: cr,
  hasStandardBrowserWebWorkerEnv: lr,
  navigator: pe,
  origin: ur
}, Symbol.toStringTag, { value: "Module" })), R = {
  ...fr,
  ...ar
};
function dr(e, t) {
  return oe(e, new R.classes.URLSearchParams(), {
    visitor: function(r, n, o, i) {
      return R.isNode && a.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function hr(e) {
  return a.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function pr(e) {
  const t = {}, r = Object.keys(e);
  let n;
  const o = r.length;
  let i;
  for (n = 0; n < o; n++)
    i = r[n], t[i] = e[i];
  return t;
}
function ot(e) {
  function t(r, n, o, i) {
    let s = r[i++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), f = i >= r.length;
    return s = !s && a.isArray(o) ? o.length : s, f ? (a.hasOwnProp(o, s) ? o[s] = [o[s], n] : o[s] = n, !l) : ((!o[s] || !a.isObject(o[s])) && (o[s] = []), t(r, n, o[s], i) && a.isArray(o[s]) && (o[s] = pr(o[s])), !l);
  }
  if (a.isFormData(e) && a.isFunction(e.entries)) {
    const r = {};
    return a.forEachEntry(e, (n, o) => {
      t(hr(n), o, r, 0);
    }), r;
  }
  return null;
}
function mr(e, t, r) {
  if (a.isString(e))
    try {
      return (t || JSON.parse)(e), a.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(e);
}
const W = {
  transitional: nt,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, t) {
    const r = t.getContentType() || "", n = r.indexOf("application/json") > -1, o = a.isObject(e);
    if (o && a.isHTMLForm(e) && (e = new FormData(e)), a.isFormData(e))
      return n ? JSON.stringify(ot(e)) : e;
    if (a.isArrayBuffer(e) || a.isBuffer(e) || a.isStream(e) || a.isFile(e) || a.isBlob(e) || a.isReadableStream(e))
      return e;
    if (a.isArrayBufferView(e))
      return e.buffer;
    if (a.isURLSearchParams(e))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let i;
    if (o) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return dr(e, this.formSerializer).toString();
      if ((i = a.isFileList(e)) || r.indexOf("multipart/form-data") > -1) {
        const s = this.env && this.env.FormData;
        return oe(
          i ? { "files[]": e } : e,
          s && new s(),
          this.formSerializer
        );
      }
    }
    return o || n ? (t.setContentType("application/json", !1), mr(e)) : e;
  }],
  transformResponse: [function(e) {
    const t = this.transitional || W.transitional, r = t && t.forcedJSONParsing, n = this.responseType === "json";
    if (a.isResponse(e) || a.isReadableStream(e))
      return e;
    if (e && a.isString(e) && (r && !this.responseType || n)) {
      const o = !(t && t.silentJSONParsing) && n;
      try {
        return JSON.parse(e, this.parseReviver);
      } catch (i) {
        if (o)
          throw i.name === "SyntaxError" ? m.from(i, m.ERR_BAD_RESPONSE, this, null, this.response) : i;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: R.classes.FormData,
    Blob: R.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
a.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  W.headers[e] = {};
});
const br = a.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), yr = (e) => {
  const t = {};
  let r, n, o;
  return e && e.split(`
`).forEach(function(i) {
    o = i.indexOf(":"), r = i.substring(0, o).trim().toLowerCase(), n = i.substring(o + 1).trim(), !(!r || t[r] && br[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, Pe = Symbol("internals");
function I(e) {
  return e && String(e).trim().toLowerCase();
}
function Q(e) {
  return e === !1 || e == null ? e : a.isArray(e) ? e.map(Q) : String(e);
}
function gr(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
const wr = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function le(e, t, r, n, o) {
  if (a.isFunction(n))
    return n.call(this, t, r);
  if (o && (t = r), !!a.isString(t)) {
    if (a.isString(n))
      return t.indexOf(n) !== -1;
    if (a.isRegExp(n))
      return n.test(t);
  }
}
function Er(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function Or(e, t) {
  const r = a.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, {
      value: function(o, i, s) {
        return this[n].call(this, t, o, i, s);
      },
      configurable: !0
    });
  });
}
let T = class {
  constructor(e) {
    e && this.set(e);
  }
  set(e, t, r) {
    const n = this;
    function o(s, l, f) {
      const c = I(l);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const u = a.findKey(n, c);
      (!u || n[u] === void 0 || f === !0 || f === void 0 && n[u] !== !1) && (n[u || l] = Q(s));
    }
    const i = (s, l) => a.forEach(s, (f, c) => o(f, c, l));
    if (a.isPlainObject(e) || e instanceof this.constructor)
      i(e, t);
    else if (a.isString(e) && (e = e.trim()) && !wr(e))
      i(yr(e), t);
    else if (a.isObject(e) && a.isIterable(e)) {
      let s = {}, l, f;
      for (const c of e) {
        if (!a.isArray(c))
          throw TypeError("Object iterator must return a key-value pair");
        s[f = c[0]] = (l = s[f]) ? a.isArray(l) ? [...l, c[1]] : [l, c[1]] : c[1];
      }
      i(s, t);
    } else
      e != null && o(t, e, r);
    return this;
  }
  get(e, t) {
    if (e = I(e), e) {
      const r = a.findKey(this, e);
      if (r) {
        const n = this[r];
        if (!t)
          return n;
        if (t === !0)
          return gr(n);
        if (a.isFunction(t))
          return t.call(this, n, r);
        if (a.isRegExp(t))
          return t.exec(n);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, t) {
    if (e = I(e), e) {
      const r = a.findKey(this, e);
      return !!(r && this[r] !== void 0 && (!t || le(this, this[r], r, t)));
    }
    return !1;
  }
  delete(e, t) {
    const r = this;
    let n = !1;
    function o(i) {
      if (i = I(i), i) {
        const s = a.findKey(r, i);
        s && (!t || le(r, r[s], s, t)) && (delete r[s], n = !0);
      }
    }
    return a.isArray(e) ? e.forEach(o) : o(e), n;
  }
  clear(e) {
    const t = Object.keys(this);
    let r = t.length, n = !1;
    for (; r--; ) {
      const o = t[r];
      (!e || le(this, this[o], o, e, !0)) && (delete this[o], n = !0);
    }
    return n;
  }
  normalize(e) {
    const t = this, r = {};
    return a.forEach(this, (n, o) => {
      const i = a.findKey(r, o);
      if (i) {
        t[i] = Q(n), delete t[o];
        return;
      }
      const s = e ? Er(o) : String(o).trim();
      s !== o && delete t[o], t[s] = Q(n), r[s] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const t = /* @__PURE__ */ Object.create(null);
    return a.forEach(this, (r, n) => {
      r != null && r !== !1 && (t[n] = e && a.isArray(r) ? r.join(", ") : r);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...t) {
    const r = new this(e);
    return t.forEach((n) => r.set(n)), r;
  }
  static accessor(e) {
    const t = (this[Pe] = this[Pe] = {
      accessors: {}
    }).accessors, r = this.prototype;
    function n(o) {
      const i = I(o);
      t[i] || (Or(r, o), t[i] = !0);
    }
    return a.isArray(e) ? e.forEach(n) : n(e), this;
  }
};
T.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
a.reduceDescriptors(T.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(n) {
      this[r] = n;
    }
  };
});
a.freezeMethods(T);
function ue(e, t) {
  const r = this || W, n = t || r, o = T.from(n.headers);
  let i = n.data;
  return a.forEach(e, function(s) {
    i = s.call(r, i, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), i;
}
function st(e) {
  return !!(e && e.__CANCEL__);
}
function M(e, t, r) {
  m.call(this, e ?? "canceled", m.ERR_CANCELED, t, r), this.name = "CanceledError";
}
a.inherits(M, m, {
  __CANCEL__: !0
});
function it(e, t, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new m(
    "Request failed with status code " + r.status,
    [m.ERR_BAD_REQUEST, m.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function Rr(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function Sr(e, t) {
  e = e || 10;
  const r = new Array(e), n = new Array(e);
  let o = 0, i = 0, s;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const f = Date.now(), c = n[i];
    s || (s = f), r[o] = l, n[o] = f;
    let u = i, b = 0;
    for (; u !== o; )
      b += r[u++], u = u % e;
    if (o = (o + 1) % e, o === i && (i = (i + 1) % e), f - s < t)
      return;
    const y = c && f - c;
    return y ? Math.round(b * 1e3 / y) : void 0;
  };
}
function Tr(e, t) {
  let r = 0, n = 1e3 / t, o, i;
  const s = (l, f = Date.now()) => {
    r = f, o = null, i && (clearTimeout(i), i = null), e(...l);
  };
  return [(...l) => {
    const f = Date.now(), c = f - r;
    c >= n ? s(l, f) : (o = l, i || (i = setTimeout(() => {
      i = null, s(o);
    }, n - c)));
  }, () => o && s(o)];
}
const ee = (e, t, r = 3) => {
  let n = 0;
  const o = Sr(50, 250);
  return Tr((i) => {
    const s = i.loaded, l = i.lengthComputable ? i.total : void 0, f = s - n, c = o(f), u = s <= l;
    n = s;
    const b = {
      loaded: s,
      total: l,
      progress: l ? s / l : void 0,
      bytes: f,
      rate: c || void 0,
      estimated: c && l && u ? (l - s) / c : void 0,
      event: i,
      lengthComputable: l != null,
      [t ? "download" : "upload"]: !0
    };
    e(b);
  }, r);
}, Fe = (e, t) => {
  const r = e != null;
  return [(n) => t[0]({
    lengthComputable: r,
    total: e,
    loaded: n
  }), t[1]];
}, Le = (e) => (...t) => a.asap(() => e(...t)), Ar = R.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (r) => (r = new URL(r, R.origin), e.protocol === r.protocol && e.host === r.host && (t || e.port === r.port)))(
  new URL(R.origin),
  R.navigator && /(msie|trident)/i.test(R.navigator.userAgent)
) : () => !0, Cr = R.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, r, n, o, i) {
      const s = [e + "=" + encodeURIComponent(t)];
      a.isNumber(r) && s.push("expires=" + new Date(r).toGMTString()), a.isString(n) && s.push("path=" + n), a.isString(o) && s.push("domain=" + o), i === !0 && s.push("secure"), document.cookie = s.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function jr(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function vr(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function at(e, t, r) {
  let n = !jr(t);
  return e && (n || r == !1) ? vr(e, t) : t;
}
const _e = (e) => e instanceof T ? { ...e } : e;
function k(e, t) {
  t = t || {};
  const r = {};
  function n(c, u, b, y) {
    return a.isPlainObject(c) && a.isPlainObject(u) ? a.merge.call({ caseless: y }, c, u) : a.isPlainObject(u) ? a.merge({}, u) : a.isArray(u) ? u.slice() : u;
  }
  function o(c, u, b, y) {
    if (a.isUndefined(u)) {
      if (!a.isUndefined(c))
        return n(void 0, c, b, y);
    } else return n(c, u, b, y);
  }
  function i(c, u) {
    if (!a.isUndefined(u))
      return n(void 0, u);
  }
  function s(c, u) {
    if (a.isUndefined(u)) {
      if (!a.isUndefined(c))
        return n(void 0, c);
    } else return n(void 0, u);
  }
  function l(c, u, b) {
    if (b in t)
      return n(c, u);
    if (b in e)
      return n(void 0, c);
  }
  const f = {
    url: i,
    method: i,
    data: i,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: l,
    headers: (c, u, b) => o(_e(c), _e(u), b, !0)
  };
  return a.forEach(Object.keys({ ...e, ...t }), function(c) {
    const u = f[c] || o, b = u(e[c], t[c], c);
    a.isUndefined(b) && u !== l || (r[c] = b);
  }), r;
}
const ct = (e) => {
  const t = k({}, e);
  let { data: r, withXSRFToken: n, xsrfHeaderName: o, xsrfCookieName: i, headers: s, auth: l } = t;
  if (t.headers = s = T.from(s), t.url = rt(at(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), l && s.set(
    "Authorization",
    "Basic " + btoa((l.username || "") + ":" + (l.password ? unescape(encodeURIComponent(l.password)) : ""))
  ), a.isFormData(r)) {
    if (R.hasStandardBrowserEnv || R.hasStandardBrowserWebWorkerEnv)
      s.setContentType(void 0);
    else if (a.isFunction(r.getHeaders)) {
      const f = r.getHeaders(), c = ["content-type", "content-length"];
      Object.entries(f).forEach(([u, b]) => {
        c.includes(u.toLowerCase()) && s.set(u, b);
      });
    }
  }
  if (R.hasStandardBrowserEnv && (n && a.isFunction(n) && (n = n(t)), n || n !== !1 && Ar(t.url))) {
    const f = o && i && Cr.read(i);
    f && s.set(o, f);
  }
  return t;
}, xr = typeof XMLHttpRequest < "u", Ur = xr && function(e) {
  return new Promise(function(t, r) {
    const n = ct(e);
    let o = n.data;
    const i = T.from(n.headers).normalize();
    let { responseType: s, onUploadProgress: l, onDownloadProgress: f } = n, c, u, b, y, p;
    function h() {
      y && y(), p && p(), n.cancelToken && n.cancelToken.unsubscribe(c), n.signal && n.signal.removeEventListener("abort", c);
    }
    let d = new XMLHttpRequest();
    d.open(n.method.toUpperCase(), n.url, !0), d.timeout = n.timeout;
    function E() {
      if (!d)
        return;
      const w = T.from(
        "getAllResponseHeaders" in d && d.getAllResponseHeaders()
      ), C = {
        data: !s || s === "text" || s === "json" ? d.responseText : d.response,
        status: d.status,
        statusText: d.statusText,
        headers: w,
        config: e,
        request: d
      };
      it(function(x) {
        t(x), h();
      }, function(x) {
        r(x), h();
      }, C), d = null;
    }
    "onloadend" in d ? d.onloadend = E : d.onreadystatechange = function() {
      !d || d.readyState !== 4 || d.status === 0 && !(d.responseURL && d.responseURL.indexOf("file:") === 0) || setTimeout(E);
    }, d.onabort = function() {
      d && (r(new m("Request aborted", m.ECONNABORTED, e, d)), d = null);
    }, d.onerror = function(w) {
      const C = w && w.message ? w.message : "Network Error", x = new m(C, m.ERR_NETWORK, e, d);
      x.event = w || null, r(x), d = null;
    }, d.ontimeout = function() {
      let w = n.timeout ? "timeout of " + n.timeout + "ms exceeded" : "timeout exceeded";
      const C = n.transitional || nt;
      n.timeoutErrorMessage && (w = n.timeoutErrorMessage), r(new m(
        w,
        C.clarifyTimeoutError ? m.ETIMEDOUT : m.ECONNABORTED,
        e,
        d
      )), d = null;
    }, o === void 0 && i.setContentType(null), "setRequestHeader" in d && a.forEach(i.toJSON(), function(w, C) {
      d.setRequestHeader(C, w);
    }), a.isUndefined(n.withCredentials) || (d.withCredentials = !!n.withCredentials), s && s !== "json" && (d.responseType = n.responseType), f && ([b, p] = ee(f, !0), d.addEventListener("progress", b)), l && d.upload && ([u, y] = ee(l), d.upload.addEventListener("progress", u), d.upload.addEventListener("loadend", y)), (n.cancelToken || n.signal) && (c = (w) => {
      d && (r(!w || w.type ? new M(null, e, d) : w), d.abort(), d = null);
    }, n.cancelToken && n.cancelToken.subscribe(c), n.signal && (n.signal.aborted ? c() : n.signal.addEventListener("abort", c)));
    const O = Rr(n.url);
    if (O && R.protocols.indexOf(O) === -1) {
      r(new m("Unsupported protocol " + O + ":", m.ERR_BAD_REQUEST, e));
      return;
    }
    d.send(o || null);
  });
}, Nr = (e, t) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (t || r) {
    let n = new AbortController(), o;
    const i = function(c) {
      if (!o) {
        o = !0, l();
        const u = c instanceof Error ? c : this.reason;
        n.abort(u instanceof m ? u : new M(u instanceof Error ? u.message : u));
      }
    };
    let s = t && setTimeout(() => {
      s = null, i(new m(`timeout ${t} of ms exceeded`, m.ETIMEDOUT));
    }, t);
    const l = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(i) : c.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", i));
    const { signal: f } = n;
    return f.unsubscribe = () => a.asap(l), f;
  }
}, Pr = function* (e, t) {
  let r = e.byteLength;
  if (r < t) {
    yield e;
    return;
  }
  let n = 0, o;
  for (; n < r; )
    o = n + t, yield e.slice(n, o), n = o;
}, Fr = async function* (e, t) {
  for await (const r of Lr(e))
    yield* Pr(r, t);
}, Lr = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: n } = await t.read();
      if (r)
        break;
      yield n;
    }
  } finally {
    await t.cancel();
  }
}, ke = (e, t, r, n) => {
  const o = Fr(e, t);
  let i = 0, s, l = (f) => {
    s || (s = !0, n && n(f));
  };
  return new ReadableStream({
    async pull(f) {
      try {
        const { done: c, value: u } = await o.next();
        if (c) {
          l(), f.close();
          return;
        }
        let b = u.byteLength;
        if (r) {
          let y = i += b;
          r(y);
        }
        f.enqueue(new Uint8Array(u));
      } catch (c) {
        throw l(c), c;
      }
    },
    cancel(f) {
      return l(f), o.return();
    }
  }, {
    highWaterMark: 2
  });
}, Be = 64 * 1024, { isFunction: G } = a, _r = (({ Request: e, Response: t }) => ({
  Request: e,
  Response: t
}))(a.global), {
  ReadableStream: De,
  TextEncoder: qe
} = a.global, Me = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, kr = (e) => {
  e = a.merge.call({
    skipUndefined: !0
  }, _r, e);
  const { fetch: t, Request: r, Response: n } = e, o = t ? G(t) : typeof fetch == "function", i = G(r), s = G(n);
  if (!o)
    return !1;
  const l = o && G(De), f = o && (typeof qe == "function" ? /* @__PURE__ */ ((h) => (d) => h.encode(d))(new qe()) : async (h) => new Uint8Array(await new r(h).arrayBuffer())), c = i && l && Me(() => {
    let h = !1;
    const d = new r(R.origin, {
      body: new De(),
      method: "POST",
      get duplex() {
        return h = !0, "half";
      }
    }).headers.has("Content-Type");
    return h && !d;
  }), u = s && l && Me(() => a.isReadableStream(new n("").body)), b = {
    stream: u && ((h) => h.body)
  };
  o && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((h) => {
    !b[h] && (b[h] = (d, E) => {
      let O = d && d[h];
      if (O)
        return O.call(d);
      throw new m(`Response type '${h}' is not supported`, m.ERR_NOT_SUPPORT, E);
    });
  });
  const y = async (h) => {
    if (h == null)
      return 0;
    if (a.isBlob(h))
      return h.size;
    if (a.isSpecCompliantForm(h))
      return (await new r(R.origin, {
        method: "POST",
        body: h
      }).arrayBuffer()).byteLength;
    if (a.isArrayBufferView(h) || a.isArrayBuffer(h))
      return h.byteLength;
    if (a.isURLSearchParams(h) && (h = h + ""), a.isString(h))
      return (await f(h)).byteLength;
  }, p = async (h, d) => a.toFiniteNumber(h.getContentLength()) ?? y(d);
  return async (h) => {
    let {
      url: d,
      method: E,
      data: O,
      signal: w,
      cancelToken: C,
      timeout: x,
      onDownloadProgress: ie,
      onUploadProgress: Ee,
      responseType: U,
      headers: ae,
      withCredentials: V = "same-origin",
      fetchOptions: Oe
    } = ct(h), Re = t || fetch;
    U = U ? (U + "").toLowerCase() : "text";
    let K = Nr([w, C && C.toAbortSignal()], x), z = null;
    const F = K && K.unsubscribe && (() => {
      K.unsubscribe();
    });
    let Se;
    try {
      if (Ee && c && E !== "get" && E !== "head" && (Se = await p(ae, O)) !== 0) {
        let P = new r(d, {
          method: "POST",
          body: O,
          duplex: "half"
        }), B;
        if (a.isFormData(O) && (B = P.headers.get("content-type")) && ae.setContentType(B), P.body) {
          const [ce, X] = Fe(
            Se,
            ee(Le(Ee))
          );
          O = ke(P.body, Be, ce, X);
        }
      }
      a.isString(V) || (V = V ? "include" : "omit");
      const j = i && "credentials" in r.prototype, Te = {
        ...Oe,
        signal: K,
        method: E.toUpperCase(),
        headers: ae.normalize().toJSON(),
        body: O,
        duplex: "half",
        credentials: j ? V : void 0
      };
      z = i && new r(d, Te);
      let N = await (i ? Re(z, Oe) : Re(d, Te));
      const Ae = u && (U === "stream" || U === "response");
      if (u && (ie || Ae && F)) {
        const P = {};
        ["status", "statusText", "headers"].forEach((Ce) => {
          P[Ce] = N[Ce];
        });
        const B = a.toFiniteNumber(N.headers.get("content-length")), [ce, X] = ie && Fe(
          B,
          ee(Le(ie), !0)
        ) || [];
        N = new n(
          ke(N.body, Be, ce, () => {
            X && X(), F && F();
          }),
          P
        );
      }
      U = U || "text";
      let pt = await b[a.findKey(b, U) || "text"](N, h);
      return !Ae && F && F(), await new Promise((P, B) => {
        it(P, B, {
          data: pt,
          headers: T.from(N.headers),
          status: N.status,
          statusText: N.statusText,
          config: h,
          request: z
        });
      });
    } catch (j) {
      throw F && F(), j && j.name === "TypeError" && /Load failed|fetch/i.test(j.message) ? Object.assign(
        new m("Network Error", m.ERR_NETWORK, h, z),
        {
          cause: j.cause || j
        }
      ) : m.from(j, j && j.code, h, z);
    }
  };
}, Br = /* @__PURE__ */ new Map(), lt = (e) => {
  let t = e ? e.env : {};
  const { fetch: r, Request: n, Response: o } = t, i = [
    n,
    o,
    r
  ];
  let s = i.length, l = s, f, c, u = Br;
  for (; l--; )
    f = i[l], c = u.get(f), c === void 0 && u.set(f, c = l ? /* @__PURE__ */ new Map() : kr(t)), u = c;
  return c;
};
lt();
const me = {
  http: er,
  xhr: Ur,
  fetch: {
    get: lt
  }
};
a.forEach(me, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const ze = (e) => `- ${e}`, Dr = (e) => a.isFunction(e) || e === null || e === !1, ut = {
  getAdapter: (e, t) => {
    e = a.isArray(e) ? e : [e];
    const { length: r } = e;
    let n, o;
    const i = {};
    for (let s = 0; s < r; s++) {
      n = e[s];
      let l;
      if (o = n, !Dr(n) && (o = me[(l = String(n)).toLowerCase()], o === void 0))
        throw new m(`Unknown adapter '${l}'`);
      if (o && (a.isFunction(o) || (o = o.get(t))))
        break;
      i[l || "#" + s] = o;
    }
    if (!o) {
      const s = Object.entries(i).map(
        ([f, c]) => `adapter ${f} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let l = r ? s.length > 1 ? `since :
` + s.map(ze).join(`
`) : " " + ze(s[0]) : "as no adapter specified";
      throw new m(
        "There is no suitable adapter to dispatch the request " + l,
        "ERR_NOT_SUPPORT"
      );
    }
    return o;
  },
  adapters: me
};
function fe(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new M(null, e);
}
function Ie(e) {
  return fe(e), e.headers = T.from(e.headers), e.data = ue.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), ut.getAdapter(e.adapter || W.adapter, e)(e).then(function(t) {
    return fe(e), t.data = ue.call(
      e,
      e.transformResponse,
      t
    ), t.headers = T.from(t.headers), t;
  }, function(t) {
    return st(t) || (fe(e), t && t.response && (t.response.data = ue.call(
      e,
      e.transformResponse,
      t.response
    ), t.response.headers = T.from(t.response.headers))), Promise.reject(t);
  });
}
const ft = "1.12.2", se = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  se[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const He = {};
se.transitional = function(e, t, r) {
  function n(o, i) {
    return "[Axios v" + ft + "] Transitional option '" + o + "'" + i + (r ? ". " + r : "");
  }
  return (o, i, s) => {
    if (e === !1)
      throw new m(
        n(i, " has been removed" + (t ? " in " + t : "")),
        m.ERR_DEPRECATED
      );
    return t && !He[i] && (He[i] = !0, console.warn(
      n(
        i,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(o, i, s) : !0;
  };
};
se.spelling = function(e) {
  return (t, r) => (console.warn(`${r} is likely a misspelling of ${e}`), !0);
};
function qr(e, t, r) {
  if (typeof e != "object")
    throw new m("options must be an object", m.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let o = n.length;
  for (; o-- > 0; ) {
    const i = n[o], s = t[i];
    if (s) {
      const l = e[i], f = l === void 0 || s(l, i, e);
      if (f !== !0)
        throw new m("option " + i + " must be " + f, m.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new m("Unknown option " + i, m.ERR_BAD_OPTION);
  }
}
const Y = {
  assertOptions: qr,
  validators: se
}, v = Y.validators;
let _ = class {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = {
      request: new Ne(),
      response: new Ne()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, t) {
    try {
      return await this._request(e, t);
    } catch (r) {
      if (r instanceof Error) {
        let n = {};
        Error.captureStackTrace ? Error.captureStackTrace(n) : n = new Error();
        const o = n.stack ? n.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? o && !String(r.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + o) : r.stack = o;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(e, t) {
    typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = k(this.defaults, t);
    const { transitional: r, paramsSerializer: n, headers: o } = t;
    r !== void 0 && Y.assertOptions(r, {
      silentJSONParsing: v.transitional(v.boolean),
      forcedJSONParsing: v.transitional(v.boolean),
      clarifyTimeoutError: v.transitional(v.boolean)
    }, !1), n != null && (a.isFunction(n) ? t.paramsSerializer = {
      serialize: n
    } : Y.assertOptions(n, {
      encode: v.function,
      serialize: v.function
    }, !0)), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : t.allowAbsoluteUrls = !0), Y.assertOptions(t, {
      baseUrl: v.spelling("baseURL"),
      withXsrfToken: v.spelling("withXSRFToken")
    }, !0), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let i = o && a.merge(
      o.common,
      o[t.method]
    );
    o && a.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (p) => {
        delete o[p];
      }
    ), t.headers = T.concat(i, o);
    const s = [];
    let l = !0;
    this.interceptors.request.forEach(function(p) {
      typeof p.runWhen == "function" && p.runWhen(t) === !1 || (l = l && p.synchronous, s.unshift(p.fulfilled, p.rejected));
    });
    const f = [];
    this.interceptors.response.forEach(function(p) {
      f.push(p.fulfilled, p.rejected);
    });
    let c, u = 0, b;
    if (!l) {
      const p = [Ie.bind(this), void 0];
      for (p.unshift(...s), p.push(...f), b = p.length, c = Promise.resolve(t); u < b; )
        c = c.then(p[u++], p[u++]);
      return c;
    }
    b = s.length;
    let y = t;
    for (; u < b; ) {
      const p = s[u++], h = s[u++];
      try {
        y = p(y);
      } catch (d) {
        h.call(this, d);
        break;
      }
    }
    try {
      c = Ie.call(this, y);
    } catch (p) {
      return Promise.reject(p);
    }
    for (u = 0, b = f.length; u < b; )
      c = c.then(f[u++], f[u++]);
    return c;
  }
  getUri(e) {
    e = k(this.defaults, e);
    const t = at(e.baseURL, e.url, e.allowAbsoluteUrls);
    return rt(t, e.params, e.paramsSerializer);
  }
};
a.forEach(["delete", "get", "head", "options"], function(e) {
  _.prototype[e] = function(t, r) {
    return this.request(k(r || {}, {
      method: e,
      url: t,
      data: (r || {}).data
    }));
  };
});
a.forEach(["post", "put", "patch"], function(e) {
  function t(r) {
    return function(n, o, i) {
      return this.request(k(i || {}, {
        method: e,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: n,
        data: o
      }));
    };
  }
  _.prototype[e] = t(), _.prototype[e + "Form"] = t(!0);
});
let Mr = class dt {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const n = this;
    this.promise.then((o) => {
      if (!n._listeners) return;
      let i = n._listeners.length;
      for (; i-- > 0; )
        n._listeners[i](o);
      n._listeners = null;
    }), this.promise.then = (o) => {
      let i;
      const s = new Promise((l) => {
        n.subscribe(l), i = l;
      }).then(o);
      return s.cancel = function() {
        n.unsubscribe(i);
      }, s;
    }, t(function(o, i, s) {
      n.reason || (n.reason = new M(o, i, s), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), r = (n) => {
      t.abort(n);
    };
    return this.subscribe(r), t.signal.unsubscribe = () => this.unsubscribe(r), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new dt(function(r) {
        t = r;
      }),
      cancel: t
    };
  }
};
function zr(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function Ir(e) {
  return a.isObject(e) && e.isAxiosError === !0;
}
const be = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(be).forEach(([e, t]) => {
  be[t] = e;
});
function ht(e) {
  const t = new _(e), r = Je(_.prototype.request, t);
  return a.extend(r, _.prototype, t, { allOwnKeys: !0 }), a.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(n) {
    return ht(k(e, n));
  }, r;
}
const g = ht(W);
g.Axios = _;
g.CanceledError = M;
g.CancelToken = Mr;
g.isCancel = st;
g.VERSION = ft;
g.toFormData = oe;
g.AxiosError = m;
g.Cancel = g.CanceledError;
g.all = function(e) {
  return Promise.all(e);
};
g.spread = zr;
g.isAxiosError = Ir;
g.mergeConfig = k;
g.AxiosHeaders = T;
g.formToJSON = (e) => ot(a.isHTMLForm(e) ? new FormData(e) : e);
g.getAdapter = ut.getAdapter;
g.HttpStatusCode = be;
g.default = g;
const {
  Axios: Vr,
  AxiosError: Hr,
  CanceledError: Kr,
  isCancel: Xr,
  CancelToken: Gr,
  VERSION: Zr,
  all: Qr,
  Cancel: Yr,
  isAxiosError: en,
  spread: tn,
  toFormData: rn,
  AxiosHeaders: nn,
  HttpStatusCode: on,
  formToJSON: sn,
  getAdapter: an,
  mergeConfig: cn
} = g, Jr = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_,+.~#?&/=]*)$/;
class $r {
  baseUrl;
  headers;
  constructor(t, r = {}) {
    this.baseUrl = t, this.headers = r?.headers || {};
  }
  async fetch(t, r = "GET", n = {}) {
    if (!this.baseUrl)
      throw new Error("No base URL set");
    const o = Jr.test(t) ? t : `${this.baseUrl}${t}`;
    o.includes(this.baseUrl) && (n.withCredentials = !0);
    try {
      return (await g(o, {
        ...n,
        method: r,
        data: n.data,
        headers: { ...this.headers, ...n.headers },
        withCredentials: n.withCredentials
      })).data;
    } catch (i) {
      throw i instanceof Hr ? new je(`${i.code} - ${i.status} - ${o}`, i.status, i.response?.data) : new je("An error occured while fetching");
    }
  }
  getBaseUrl() {
    return this.baseUrl;
  }
  setBaseUrl(t) {
    this.baseUrl = t;
  }
  async get(t, r = {}) {
    return this.fetch(t, "GET", r);
  }
  async post(t, r = {}) {
    return this.fetch(t, "POST", {
      ...r,
      headers: {
        "Content-Type": "application/json",
        ...r.headers
      }
    });
  }
  async put(t, r = {}) {
    return this.fetch(t, "PUT", {
      ...r,
      headers: {
        "Content-Type": "application/json",
        ...r.headers
      }
    });
  }
  async delete(t, r = {}) {
    return this.fetch(t, "DELETE", r);
  }
  async patch(t, r = {}) {
    return this.fetch(t, "PATCH", {
      ...r,
      headers: {
        "Content-Type": "application/json",
        ...r.headers
      }
    });
  }
}
let Wr;
function ln(e, t = {}) {
  Wr = new $r(e, t);
}
export {
  Wr as heFetch,
  ln as setLandingPageFetchConfig
};
